import axios from 'axios';
const apiUrl = process.env.API_URL;

export default {
  deactivateOktaUser(uid, reqType) {
    if (reqType === "deactivateoktauser") {
      return axios.post(`${apiUrl}/auth/users/${uid}/deactivate`, {});
    } else if (reqType === "deleteoktauser") {
      return axios({
        method: 'delete',
        url: `${apiUrl}/auth/users/${uid}`,
        data: null,
        headers: {'Content-Type': 'application/json'}
      })
    }
  },
  activateOktaUser(uid) {
    return axios.post(`${apiUrl}/auth/users/${uid}/activate`, {});
  }
}



// WEBPACK FOOTER //
// ./src/helpers/auth-api.js